import React, { Fragment, useMemo, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Card, CardBody, CardFooter, Col, FormGroup, Input, Label, Row } from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import CustomFilter from "Components/ReactTable/Filters/CustomFilters";
import DefaultModal from "Components/Modal/DefaultModal";
import ReactTableGeneric from "Components/ReactTableGeneric";
import { BsArrowRightCircle } from "react-icons/bs";
import TextLimit from "Api/TextLimit";
import { useFeedbackList, useUpdateFeedback } from "Api/Melder/Feedback";

const Default = () => {
    const [selectedOrganization, setSelectedOrganization] = useState(null);
    const [modal, setModal] = useState(false);
    const [current, setCurrent] = useState("");
    const [iSubsDateId, setISubsDateId] = useState("");

    const {
        data: feedbackResponse,
        mutate,
        error,
        isLoading,
    } = useFeedbackList();

    const {
        trigger: updateFeedback,
        isLoading: updateLoading,
    } = useUpdateFeedback();

    const feedbackList = feedbackResponse?.feedback || [];
    const contracts = feedbackResponse?.contractTypes || [];
    const totalCount = feedbackResponse?.totalCount;


    const filterData = useMemo(() => {
        return [
            ...new Map(
                (feedbackList || []).map(item => [
                    item.organization,
                    {
                        filterName: item.organization,
                        filterId: item.organization,
                    },
                ])
            ).values(),
        ];
    }, [feedbackList]);

    const tableData = useMemo(() => {
        if (!selectedOrganization) return feedbackList || [];

        return (feedbackList || []).filter(
            item => item.organization === selectedOrganization
        );
    }, [feedbackList, selectedOrganization]);

    const toggle = () => {
        setModal((prev) => !prev);
    };

    const openModel = (subDateId) => {
        setISubsDateId(subDateId);
        setCurrent("");
        setModal(true);
    };

    const handleChange = (event) => {
        setCurrent(event.target.value);
    };

    const select = () => {
        setModal(false);
    };

    const handleSubmit = async () => {
        const postdata = {
            iSubdateId: iSubsDateId,
            iAdminId: Number(current),
            note: "",
        };

        if (!iSubsDateId || !current) return;

        try {
            const response = await updateFeedback({ data: postdata });

            if (response?.status || response?.data?.status) {
                mutate();
            }
        } catch (err) {
            console.log("error updating feedback", err);
        } finally {
            setModal(false);
        }
    };

    const handleSelect = (selectedValue) => {
        setSelectedOrganization(selectedValue);
    };

    // const tableData = useMemo(() => {
    //     if (!selectedOrganization) return filterData;

    //     return filterData.filter(
    //         (item) => item.organization === selectedOrganization
    //     );
    // }, [filterData, selectedOrganization]);

    const columns = useMemo(
        () => [
            {
                header: () => "Datum",
                accessorKey: "date",
            },
            {
                header: () => "Dag",
                accessorKey: "day",
            },
            {
                header: () => "Dagdeel",
                accessorKey: "daypart",
            },
            {
                header: () => "Verzoek",
                accessorKey: "verzoek",
            },
            {
                header: () => "Organisatie",
                accessorKey: "organization",
                cell: (value) => {
                    return window.innerWidth > 1250
                        ? TextLimit.limitStringLargeScreen(
                            value.row.original.organization
                        )
                        : TextLimit.limitStringSmallScreen(
                            value.row.original.organization
                        );
                },
            },
            {
                header: () => "School",
                accessorKey: "afdeling",
                cell: (value) => {
                    return window.innerWidth > 1250
                        ? TextLimit.limitStringLargeScreen(
                            value.row.original.afdeling
                        )
                        : TextLimit.limitStringSmallScreen(
                            value.row.original.afdeling
                        );
                },
            },
            {
                header: () => "Afwezige",
                accessorKey: "Te_vervangen",
                cell: (value) => {
                    return window.innerWidth > 1250
                        ? TextLimit.AfwezigeLimitOptionOne(
                            value.row.original.vFirstName,
                            value.row.original.vMiddleName,
                            value.row.original.vLastName
                        )
                        : TextLimit.AfwezigeLimitOptionTwo(
                            value.row.original.vFirstName,
                            value.row.original.vMiddleName,
                            value.row.original.vLastName
                        );
                },
            },
            {
                header: () => "Actie",
                accessorKey: "info",
                cell: (cell) => (
                    <BsArrowRightCircle
                        className="cursor-pointer arrow-icon-size"
                        onClick={() => openModel(cell.row.original.iSubsDateId)}
                    />
                ),
            },
        ],
        []
    );

    return (
        <Fragment>
            <PageHeading/>
            <TransitionOnLoad>
                <div>
                    <Row>
                        <Col md="12" lg="12">
                            <Card className="main-card mb-3">
                                <CardBody className="p-3">
                                    <DefaultModal
                                        modal={modal}
                                        toggle={toggle}
                                        select={select}
                                        handleSubmit={handleSubmit}
                                        classes="feedback-modal-style"
                                    >
                                        <FormGroup>
                                            <div>
                                                {contracts.length > 0
                                                    ? contracts.map((item) => (
                                                        <FormGroup
                                                            check
                                                            key={item.iAdminId}
                                                        >
                                                            <Input
                                                                name="contracts"
                                                                value={item.iAdminId}
                                                                type="radio"
                                                                onChange={handleChange}
                                                                checked={
                                                                    String(current) ===
                                                                    String(item.iAdminId)
                                                                }
                                                            />{" "}
                                                            <Label check>
                                                                {item.name}
                                                            </Label>
                                                        </FormGroup>
                                                    ))
                                                    : null}
                                            </div>
                                        </FormGroup>
                                    </DefaultModal>

                                    <ReactTableGeneric
                                        data={tableData}
                                        columns={columns}
                                        tableClassName="mb-0 table table-borderless table-sm table-hover"
                                        count={totalCount}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </TransitionOnLoad>

            <div className="chat-layout-footer verzoken-footer-height">
                <CardFooter className="chat-layout-footer__inner gebruikers-footer">
                    <CustomFilter
                        data={filterData}
                        handleCallback={handleSelect}
                    />
                </CardFooter>


            </div>
        </Fragment>
    );
};

export default Default;

